import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../../../../../translations/lang/en-US.json';
import DiningAddress from './DiningAddress';

class OrderDetails extends PureComponent {
  render() {
    const { orderDescription:{
      orderType = '',
      deliveryInstructions = '', 
      customerAddress
    } } = this.props;

    return (
      <div className="col-md-6">
        <DiningAddress orderType={orderType} customerAddress={customerAddress} />
        <br />
        {deliveryInstructions !== '' ? (
        <div>
          <small>
            <div className="olo-client-theme-color capitalize">
              <b>
              {' '}
              <FormattedMessage
                id="orderTypeSpecialInstruction"
                defaultMessage={defaultMsg.orderTypeSpecialInstruction}
              />
              {' '}
              :
              </b>
            </div>
            <div className="break-word">
              <FormattedMessage
                id="specialInstruction"
                defaultMessage={defaultMsg.specialInstruction}
                values={{ type: deliveryInstructions }}
              />
            </div>
          </small>
        </div>
        ) : null}
      </div>
    );
  }
}

export default OrderDetails;


// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/OrderDetails/index.jsx